import { ApolloClient, createHttpLink, InMemoryCache, type TypePolicies } from '@apollo/client'

export const createApolloClient = (
  uri: string = 'http://localhost:3333/api/v1/graphql',
  options: { headers?: Record<string, string>; typePolicies?: TypePolicies } = {},
) => {
  const httpLink = createHttpLink({
    uri,
    // Add credentials if needed for cookies
    credentials: 'include',
    headers: {
      'X-Csrf-Protection': '1',
      ...(options.headers || {}),
    },
  })

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache({ typePolicies: options.typePolicies }),
  })
}

export const defaultClient = createApolloClient()

export type { ApolloCache, Reference, TypedDocumentNode, TypePolicies } from '@apollo/client'
export { gql, InMemoryCache } from '@apollo/client'
export { CombinedGraphQLErrors } from '@apollo/client/errors'
export {
  ApolloProvider,
  skipToken,
  useApolloClient,
  useFragment,
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
  useSuspenseQuery,
} from '@apollo/client/react'
export * from '@apollo/client/testing'
export { MockedProvider } from '@apollo/client/testing/react'
